const getProductType = (productTypeFromGraph)=>{
    /*
    NOTE: The Product cases are still relevant until the BE moves to the new shopping list response format
    which returns a variant instead of a product type.
    This will be done in https://jira.grandvision.global/browse/MACC-16022. Until then we need to
    keep this code for mutations and queries to support the old/current shopping list response format.
  */ switch(productTypeFromGraph){
        case 'AccessoriesProduct':
        case 'AccessoriesVariant':
            return 'accessories';
        case 'ContactLensProduct':
        case 'ContactLensVariant':
            return 'contact-lenses';
        case 'FrameProduct':
        case 'FrameVariant':
            return 'frames';
        case 'ReadyReaderProduct':
        case 'ReadyReaderVariant':
            return 'ready-readers';
        case 'SolutionProduct':
        case 'SolutionVariant':
            return 'solutions';
        case 'SunglassesProduct':
        case 'SunglassesVariant':
            return 'sunglasses';
        default:
            return 'sunglasses';
    }
};

export { getProductType };
//# sourceMappingURL=get-shopping-list-product-type.js.map
